// extracted by mini-css-extract-plugin
export default {"notFoundPage":"NotFound_notFoundPage__7loKa","head":"NotFound_head__IVjsj","pageHeader":"NotFound_pageHeader__zVWRc","pageDescription":"NotFound_pageDescription__Ker7n"};